import {  TextArea } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { addFaqApi } from "services/faq";
import { toastMessage } from "utils/toastMessage";
import {ValidateInput} from "validation";
import { faq } from "validation/schema/faq";

export const AddFAQModel = ({ addFaqModal, faqListHandler, closeModel }) => {
  const [error, setError] = useState({});
  const [inputData, setInputData] = useState({
    question: "",
    answer: "",
  });
  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");

  // On Change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  // Input Validation
  const validation = () => {
    const { errors, status } = ValidateInput(
      inputData,
      "addFaqSchema",
      faq,
      null
    );
    setError(errors);
    return status;
  };

  // Add Faq close modal
  const addFaqCloseModal = () => {
    setInputData({});
    setError({});
    closeModel();
  };

  // Add faq handler

  const addFaqHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoader(true);
      try {
        const { data: responseData, status } = await addFaqApi(inputData);
        if (status === 200) {
          faqListHandler();
          addFaqCloseModal();
          toastMessage(responseData?.message, "success", "addFaq");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <CustomModal
      className={"add_model"}
      show={addFaqModal}
      handleClose={addFaqCloseModal}
    >
      <h3>Add FAQ</h3>
      <div className="add_model">
        <div className="form_field_wrap">
          {/* Title */}
          <div className="form_field">
            <TextArea
              label="Question"
              placeholder="Enter FAQ Question"
              name="question"
              value={inputData?.question || ""}
              onChange={onChangeHandler}
              error={error?.question}
              style={{ resize: "none" }}
              maxLength = {200}
            />
          </div>
        </div>
        {/* Description */}
        <div className="form_field">
          <TextArea
            label="Answer"
            placeholder="Enter FAQ Answer"
            name="answer"
            value={inputData?.answer || ""}
            onChange={onChangeHandler}
            error={error?.answer}
            style={{ resize: "none" }}
            maxLength={500}
          />
        </div>
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addFaqCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={addFaqHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};
